import type React from 'react';

import * as styles from './styles';
import queryString from 'query-string';

import { Location, type UUID } from '@cobliteam/common-types';

import { Analytics } from '@cobliteam/analytics';

import { TripsIcon } from '@cobliteam/base-components';

import { Button } from '@cobliteam/ui/components';

import type { ProcessedStopRouteStep } from '../../../../store';
import { StopPopup } from '../../../StopPopup/StopPopup';

export interface HistoryStopPopupProps {
  stop: ProcessedStopRouteStep;
  vehicleId: UUID;
  idleTimeHighlighted: boolean;
  filteredDuration?: number;
}

export const HistoryStopPopup: React.FC<HistoryStopPopupProps> = ({
  stop,
  vehicleId,
  idleTimeHighlighted,
  filteredDuration,
}) => {
  const handleCheckMap = () => {
    Analytics.track(
      'Opened Vehicle Tracking On Map From Tracking History Stop Popup'
    );

    const params = queryString.stringify({
      vehicle_id: vehicleId,
      date: stop.startTime,
      event_type: 'stop',
      event_step: stop.index + 1,
    });
    const url = `${window.location.origin}/#${Location.TRACKING}?${params}`;
    window.open(url, '_blank')!.focus();
  };

  return (
    <StopPopup
      arrow={false}
      stop={stop}
      filteredDuration={filteredDuration}
      idleTimeHighlighted={idleTimeHighlighted}
    >
      <div className={styles.historyStopActionArea}>
        <Button
          variant="text"
          startIcon={<TripsIcon />}
          onClick={handleCheckMap}
        >
          Ver o trajeto
        </Button>
      </div>
    </StopPopup>
  );
};
